import React from 'react';
import {connect} from "react-redux";
import PagePermission from "components/permission/PagePermission";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsDataTable from "components/data-table/BsDataTable";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import BsTabPanel from "components/panel/BsTabPanel";
import BICYCLE_REPORTS_TABLE from "./bicycle-reports-table";
import {MANAGER} from "core/utils/permissions";
import {loadBikeReports} from "core/actions/bike-report-actions";

const queryString = require('query-string');

class BicycleReportsTab extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction
    };

    this.onLoadData(query);
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  onLoadData = (query) => {
    this.props.loadBikeReports(this.props.match.params.systemId, this.prepareQuery(query));
  }

  onRowClick = (row) => {
    this.props.history.push('/system/' + this.props.match.params.systemId + '/bicycle-info/' +
        this.props.match.params.bicycleId + '/report/' + row.id)
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    }
    query['bike.id'] = this.props.match.params.bicycleId

    return query
  }

  render() {
    return (
        <BsTabPanel>
          <PagePermission anonymous={false} permission={MANAGER}/>
          <BsPanelLoader show={this.props.loading}/>
          <BsPanelHeader>
            <BsPanelTitle/>
          </BsPanelHeader>

          <BsDataTable location={this.props.location}
                       history={this.props.history}
                       order={this.state.direction}
                       orderBy={this.state.sort}
                       settings={BICYCLE_REPORTS_TABLE}
                       content={this.props.reports}
                       onRowClick={this.onRowClick}
                       onChangePage={this.onLoadData}
                       onChangeSize={this.onLoadData}
                       onRequestSort={this.onRequestSort}/>
        </BsTabPanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reports: state.bikeReports.reports,
    loading: state.clientUser.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadBikeReports: (systemId, query) => {
      dispatch(loadBikeReports(systemId, query));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BicycleReportsTab);
